<template>
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
            d="M11.5661 1.35484C11.2795 1.35484 11.0049 1.46848 10.8026 1.67034L10.2293 2.24249L11.7544 3.7645L12.3296 3.19043C12.5318 2.98862 12.6452 2.7152 12.6452 2.43039C12.6452 2.14557 12.5318 1.87215 12.3296 1.67034C12.1273 1.46848 11.8527 1.35484 11.5661 1.35484ZM10.7954 4.72156L9.27035 3.19955L1.35484 11.0993V12.6452H2.85596L10.7954 4.72156ZM9.84557 0.711365C10.3021 0.25573 10.921 0 11.5661 0C12.2112 0 12.8301 0.25573 13.2867 0.711365C13.7432 1.16705 14 1.78537 14 2.43039C14 3.0754 13.7432 3.69372 13.2867 4.14941L3.61468 13.8021C3.48768 13.9288 3.31558 14 3.13616 14H0.677419C0.303291 14 0 13.6967 0 13.3226V10.8183C0 10.6384 0.0715567 10.4659 0.19889 10.3388L9.84557 0.711365Z"
            fill="#1E242C" />
    </svg>
</template>
<script>
export default {
}
</script>